import { AccountsTypeEnum } from "../../orders/api/Representation";
export var DebtorInvoiceChargeTypeEnum;
(function (DebtorInvoiceChargeTypeEnum) {
    DebtorInvoiceChargeTypeEnum["CONSIGNMENT_FEE"] = "CONSIGNMENT_FEE";
    DebtorInvoiceChargeTypeEnum["CONSIGNMENT_FREIGHT"] = "CONSIGNMENT_FREIGHT";
    DebtorInvoiceChargeTypeEnum["CONSIGNMENT_FREIGHT_FEE"] = "CONSIGNMENT_FREIGHT_FEE";
    DebtorInvoiceChargeTypeEnum["DIRECT_SALE_ITEM"] = "DIRECT_SALE_ITEM";
    DebtorInvoiceChargeTypeEnum["DIRECT_SALE_FEE"] = "DIRECT_SALE_FEE";
    DebtorInvoiceChargeTypeEnum["DIRECT_SALE_ITEM_FEE"] = "DIRECT_SALE_ITEM_FEE";
    DebtorInvoiceChargeTypeEnum["PICKUP_COLLECTED_ITEM"] = "PICKUP_COLLECTED_ITEM";
    DebtorInvoiceChargeTypeEnum["PICKUP_COLLECTED_FEE"] = "PICKUP_COLLECTED_FEE";
    DebtorInvoiceChargeTypeEnum["PICKUP_COLLECTED_ITEM_FEE"] = "PICKUP_COLLECTED_ITEM_FEE";
})(DebtorInvoiceChargeTypeEnum || (DebtorInvoiceChargeTypeEnum = {}));
